import React from 'react';

import Box from '../Box/Box';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';

export type TLinkBase = {
  href: string;
  onClick: (e?: any) => void;
  kind?: 'block' | 'isolated' | 'paragraph';
  target?: string;
  className?: string;
  rel?: string;
} & React.HTMLAttributes<any>;

const LinkBase = ({ kind, href, onClick, ...rest }: TLinkBase) => {
  const conditionalProps = filterConditionalKeyValues({
    modifiers: kind || 'isolated',
  });

  return <Box {...rest} as={!href ? 'button' : 'a'} onClick={onClick} href={href} {...conditionalProps} name="Link" />;
};

export default LinkBase;
